import { Loading } from 'src/shared/components/ui/loaders/loading';
import ShimmerLoader from 'src/shared/components/ui/loaders/shimmer-loader';
import { Separator } from 'src/shared/components/ui/separator';

/**
 * Skeleton matching the app code editor layout.
 * Used as a `pendingComponent` so the transition from the list
 * view (with SideNav) to the full-screen editor feels smooth.
 */
export function AppEditorSkeleton() {
  return (
    <div className="w-full h-screen flex flex-col">
      <div className="flex items-center justify-between bg-white px-3 h-[45px] shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded bg-gray-100 animate-pulse" />
          <ShimmerLoader width={180} height={18} />
        </div>
        <div className="flex gap-2 items-center">
          <div className="h-7 w-16 rounded bg-gray-50 animate-pulse" />
          <div className="h-7 w-16 rounded bg-gray-50 animate-pulse" />
        </div>
      </div>
      <Separator />
      <div className="flex-1 flex items-center justify-center bg-muted">
        <Loading size={24} />
      </div>
    </div>
  );
}
